// 192.168.225.59  serverpostBookingpaymentRegistration: 103.235.106.127    //66.29.149.191   https://parmartours.com:8443/parmartour/v1.0/  //local http://192.168.1.2:8443/
const baseURL = "https://parmartours.com:8443/parmartour/v1.0/"; //  https://www.travelpack365.com/
//v1.54254785215/   "https://travelpack365.com:8443/parmartour/v1.0/"
const baseURLMof = "https://parmartours.com:8443/parmartour/mof/";
const imagebaseUrl = "https://parmartours.com:8443/"; // server for image https://travelpack365.com:8443/  Test Server http://103.235.106.127:8080/parmartour/
const ticketUrl = "https://66.29.149.191:8443/parmartour/v1.0/";
const requests = {
  // https://66.29.149.191:8443/parmartour/v1.0/getTicketTypeForAttraction  http://192.168.0.101:8443/v1.0/

  apiKey: "uZFEucIHAbqvgT7p87qC4Ms4tjqG34su",
  getMealTypeActiveList: baseURL + "getMealTypeActiveList",
  getMealTicketList: baseURL + "getMealTicketList",
  getMealType: baseURL + "getMealType",
  getAttTimeSlotList: baseURL + "getAttTimeSlotList",
  getGenerateTicketWithRef: baseURL + "getGenerateTicketWithRef",
  downloadBookedTicket: ticketUrl + "downloadBookedTicket",
  setStripeBurjKhalifaPaymentsDetail:
    baseURL + "setStripeBurjKhalifaPaymentsDetail",
  setTestStripeBurjKhalifaPaymentsDetail:
    baseURL + "setTestStripeBurjKhalifaPaymentsDetail",
  getAttractionHolidayListDto: baseURL + "getAttractionHolidayListDto",
  getVisaList: baseURL + "getVisaList",
  setComboBooking: baseURL + "setComboBooking",
  getComboOffer: baseURL + "getComboOffer",
  getComboOfferList: baseURL + "getComboOfferList",
  getTourCategoryList: baseURL + "getTourCategoryList",
  checkAddonBarcodeAvailability: baseURL + "checkAddonBarcodeAvailability",
  getWebsiteBannerImagesList: baseURL + "getWebsiteBannerImagesList",
  setCartInfo: baseURL + "setCartInfo",
  getAttractionListForUpdate: baseURL + "getAttractionListForUpdate",
  deleteCartInfo: baseURL + "deleteCartInfo",
  getCartInfoList: baseURL + "getCartInfoList",
  setVisaEnquiry: baseURL + "setVisaEnquiry",
  getagencylist: baseURL + "getagencylist",
  getPaymentConfirmationBurjKhalifa:
    baseURL + "getPaymentConfirmationBurjKhalifa",
  confirmBurjTicket: baseURL + "confirmBurjTicket",
  confirmBurjKhalifaTicket: baseURL + "confirmBurjKhalifaTicket",
  saveBurjTicket: baseURL + "saveBurjTicket",
  getBurjTicketTypeWithRates: baseURL + "getBurjTicketTypeWithRates",
  getBurjTimeSlotWithRates: baseURL + "getBurjTimeSlotWithRates",
  getBurjTimeSlot: baseURL + "getBurjTimeSlot",
  getBurjKhalifaTimeSlot: baseURL + "getBurjKhalifaTimeSlot",
  getBurjKhalifaTicketTypes: baseURL + "getBurjKhalifaTicketTypes",
  getBurjKhalifaSaveTicket: baseURL + "getBurjKhalifaSaveTicket",
  getSalesReportForPark: baseURL + "getSalesReportForPark",
  getAgencyPaymentUrl: baseURL + "getAgencyPaymentUrl",
  getSalesReportForB2b: baseURL + "getSalesReportForB2b",
  getSalesReportForB2bFromTest: baseURL + "getSalesReportForB2bFromTest",
  getSalesReportForPark: baseURL + "getSalesReportForPark",
  getPaymentConfirmation: baseURL + "getPaymentConfirmation",
  getPaymentGatewayUrl: baseURL + "getPaymentGatewayUrl",
  paymentRegistration: baseURL + "paymentRegistration",
  getAttractionTicketTypePrice: baseURL + "getAttractionTicketTypePrice",
  getTicketTypeListByAttraction: baseURL + "gettickettypelistbyattraction",
  getTicketGroupListForAttraction: baseURL + "getTicketGroupListForAttraction",
  getattractionallbygroup: baseURL + "getattractionallbygroup",
  getagencydetails: baseURL + "getagencydetails",
  getAttractionAll: baseURL + "getattractionall",
  getImgBaseUrl: imagebaseUrl + "filestorage/parmartour/images/",
  getAttractionDetails: baseURL + "getattractiondetails",
  getTourPackageList: baseURL + "gettourpackageall",
  getTourPackageSingle: baseURL + "gettourpackageDetails",
  getallparkgroup: baseURL + "getattractiongrouplist",
  setaddonformlist: baseURL + "setaddonformlist",
  getaddonbannerlist: baseURL + "getaddonbannerlist",
  getuserlogindetails: baseURL + "getloginuserdetails",
  setotpforexistinguser: baseURL + "setotpforexistinguser",
  updatePasswordForUser: baseURL + "updatePasswordForUser",
  postBooking: baseURL + "setbooking",
  setloginuserdetails: baseURL + "setloginuserdetails",
  verifyotpuser: baseURL + "verifyotpuser",
  getVisaList: baseURL + "getVisaList",
  setenquiry: baseURL + "setenquiry",
  setStripePaymentsDetail: baseURL + "setStripePaymentsDetail",
  setTestStripePaymentsDetail: baseURL + "setTestStripePaymentsDetail",
  imgpath: imagebaseUrl + "filestorage/parmartour/images/",
  setBookingIp: baseURL + "setBookingIp",
  setagencyuser: baseURL + "setagencyuser",
  getagencyuserlistforagency: baseURL + "getagencyuserlistforagency",
  setNetworkPaymentsDetail: baseURL + "setNetworkPaymentsDetail",
  getAttractionListB2C: baseURL + "getAttractionListB2C",
  setuserroleslist: baseURL + "setuserroleslist",
  setagencyuser: baseURL + "setagencyuser",
  gettransactionlist: baseURL + "gettransactionlist",
  getTopupList: baseURL + "getTopupList",
  getAvailability: baseURLMof + "getAvailability",
  addToCart: baseURLMof + "addToCart",
  confirmTicket: baseURLMof + "confirmTicket",
  emptyShopCart: baseURLMof + "emptyShopCart",
  removeShopCart: baseURLMof + "removeShopCart",
  getTicketPrice: baseURLMof + "getTicketPrice",
  editShopCart: baseURLMof + "editShopCart",
};
export default requests;
